var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pilot-trials',{attrs:{"mode":"practice"}})
}
var staticRenderFns = []

export { render, staticRenderFns }